import i18next from "i18next";

class SignalStrengthHelper {
  static LAIRD_LORA_DEVICE_TYPES = ['lairdrs1xx', 'draginolht65',  'draginolht65n', 'draginolds02', 'mokolw005mp'];

  static renderRating(signalType, entity) {
    if (signalType === 'rssi') {
      const found = entity.currentMeasurements.find(measurement => measurement.originatingDeviceDataTypeToken === 'rssi');
      if (found?.lastReceivedData?.numericValue) {
        return this.renderRSSIRating(found.lastReceivedData.numericValue);
      }
    } else if (signalType === 'lqi') {
      const found = entity.currentMeasurements.find(measurement => measurement.originatingDeviceDataTypeToken === 'lqi');
      if (found?.lastReceivedData?.numericValue) {
        return this.renderLQIRating(found.lastReceivedData.numericValue);
      }
    } else if (signalType === 'lora_snr') {
      const found = entity.currentMeasurements.find(measurement => measurement.originatingDeviceDataTypeToken === 'lora_snr');
      if (found?.lastReceivedData?.numericValue) {
        return this.renderLoRaSNRRating(found.lastReceivedData.numericValue);
      }
    }

    return "black";
  }

  static renderFirstRating(entity) {
    const rssiFound = entity.currentMeasurements.find((measurement) => measurement.originatingDeviceDataTypeToken === "rssi");
    if (rssiFound?.lastReceivedData?.numericValue) {
      return this.renderRSSIRating(rssiFound.lastReceivedData.numericValue);
    } 
    
    const lqiFound = entity.currentMeasurements.find((measurement) => measurement.originatingDeviceDataTypeToken === "lqi");
    if (lqiFound?.lastReceivedData?.numericValue) {
      return this.renderLQIRating(lqiFound.lastReceivedData.numericValue);
    } 
    
    const loraSNRFound = entity.currentMeasurements.find((measurement) => measurement.originatingDeviceDataTypeToken === "lora_snr");
    if (loraSNRFound?.lastReceivedData?.numericValue) {
      return this.renderLoRaSNRRating(loraSNRFound.lastReceivedData.numericValue);
    }

    const cellRSSIFound = entity.currentMeasurements.find((measurement) => measurement.originatingDeviceDataTypeToken === "cell_rssi");
    if (cellRSSIFound?.lastReceivedData?.numericValue) {
      return this.renderCellRSSIRating(cellRSSIFound.lastReceivedData.numericValue);
    }

    return "black";
  }  

  static renderRSSIValue(value, deviceTypeToken) {
    if (value === null || isNaN(value))
      return i18next.t('unknown')

    if (deviceTypeToken && this.LAIRD_LORA_DEVICE_TYPES.includes(deviceTypeToken)) {
      if (value >= -30)
        return i18next.t('good')
      if (value > -120)
        return i18next.t('fair')
      if (value > -130)
        return i18next.t('poor')
    } else {
      if (value > -70)
        return i18next.t('good')
      if (value > -80)
        return i18next.t('fair')
      if (value > -90)
        return i18next.t('poor')
    }
    return i18next.t('offline')
  }

  static renderRSSIRating(value, deviceTypeToken) {
    if (value === null || isNaN(value)) {
      return 'red';
    }

    if (deviceTypeToken && this.LAIRD_LORA_DEVICE_TYPES.includes(deviceTypeToken)) {
      if (value >= -30)
        return 'green'
      if (value > -120)
        return 'yellow'
      if (value <= -120)
        return 'red'
    } else {
      if (value > -70) 
        return 'green';
      if (value > -80)
        return 'yellow';
      if (value <= -80) 
        return 'red';
    }    
  }

  static renderCellRSSIRating(value) {
    if (value === null || isNaN(value))
      return "red";
   
    if (value >= -65)
      return "green";
    if (value > -75)
      return "green";
    if (value > -85)
      return "yellow";
    if (value > -95)
      return "red";
    
    return "red";
  }

  static renderLTESINRValue(value) {
    if (value === null || isNaN(value))
      return i18next.t('unknown')
   
    if (value >= 20)
      return i18next.t('excellent')
    if (value > 13)
      return i18next.t('good')      
    if (value > 0)
      return i18next.t('poor')
    
    return i18next.t('bad')
  }

  static renderLTERSRPValue(value) {
    if (value === null || isNaN(value))
      return i18next.t('unknown')
   
    if (value >= -80)
      return i18next.t('excellent')
    if (value > -90)
      return i18next.t('good')      
    if (value > -95)
      return i18next.t('fair')
    if (value >= -100)
      return i18next.t('poor')
    
    return i18next.t('bad')
  }
    
  static renderLTERSRQValue(value) {
    if (value === null || isNaN(value))
      return i18next.t('unknown')
   
    if (value >= -10)
      return i18next.t('excellent')
    if (value > -15)
      return i18next.t('good')      
    if (value >= -20)
      return i18next.t('poor')
    
    return i18next.t('bad')
  }

  static renderLTERSSIValue(value) {
    if (value === null || isNaN(value))
      return i18next.t('unknown')
   
    if (value >= -65)
      return i18next.t('excellent')
    if (value > -75)
      return i18next.t('good')      
    if (value > -85)
      return i18next.t('fair')
    if (value > -95)
      return i18next.t('poor')
    
    return i18next.t('offline')
  }

  static renderLQIRating(value) {
    if (value === null || isNaN(value) || value <= 200) {
      return 'red';
    }
    if (value > 200 && value <= 230) {
      return 'yellow';
    }
    if (value > 230) {
      return 'green';
    }
  }

  // A value closer to +10 dB means that the received signal is less corrupted
  static renderLoRaSNRRating(value) {
    if (value === null || isNaN(value) || value <= -7) {
      return 'red';
    }
    if (value > -7 && value <= 5) {
      return 'yellow';
    }
    if (value > 5) {
      return 'green';
    }
  }  
}

export default SignalStrengthHelper;
